<template>
    <div>
        <el-form :inline="true" :model="searchVal">
            <el-form-item label="身份">
                <el-select v-if="identity" v-model="searchVal.identity" placeholder="请选择" :size="input_size">
                    <el-option
                            v-for="(item,key) in identity"
                            :key="key"
                            :label="item"
                            :value="key">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="uid">
                <el-input v-model="searchVal.user_id" placeholder="请输入uid" :size="input_size"></el-input>
            </el-form-item>
            <el-form-item label="用户名">
                <el-input v-model="searchVal.username" placeholder="请输入用户名" :size="input_size"></el-input>
            </el-form-item>
            <el-form-item label="真实姓名">
                <el-input v-model="searchVal.real_name" placeholder="请输入真实姓名" :size="input_size"></el-input>
            </el-form-item>
            <el-form-item label="关联状态" v-if="!alreadyRelation">
                <el-select v-model="searchVal.is_join" placeholder="请选择" :size="input_size">
                    <el-option key="0"  label="全部"  value="0"></el-option>
                    <el-option key="1" label="已关联" value="1"></el-option>
                    <el-option key="2"  label="未关联" value="2"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" icon="el-icon-search" @click="submitSearch" :size="input_size">搜索</el-button>
                <slot name="button"></slot>&nbsp;
                <el-button :size="input_size" type="primary" v-if="Acs('/customer/accounts/export')" @click="exportAccount">导出账号</el-button>
            </el-form-item>
        </el-form>
        <el-table v-loading="loading" ref="multipleTable" :data="accounts" border  size="mini"
                  @select="handleSelectionChange" @row-click="rowClick" @select-all="handleAllSelect" @selection-change="handleChange" >
            <template slot="empty" v-if="!alreadyRelation">
                <el-button type="primary" size="mini" @click="toAccount">暂无可关联账号,请先注册账号</el-button>
            </template>
            <el-table-column type="expand" v-if="alreadyRelation && group_id " >
                <template slot-scope="props">
                    <el-form label-position="right" inline  class="demo-table-expand">
                        <el-form-item label="使用学币：">
                            总:<span>{{ typeof consumer_data.userCoin[props.row.user_id] != "undefined" ? consumer_data.userCoin[props.row.user_id]['total_coin']:0 }}</span>
                            普:<span>{{typeof consumer_data.userCoin[props.row.user_id] != "undefined" ?consumer_data.userCoin[props.row.user_id]['ordinary_coin']:0 }}</span>
                            精:<span>{{ typeof consumer_data.userCoin[props.row.user_id] != "undefined" ?consumer_data.userCoin[props.row.user_id]['fine_coin']:0}}</span>
                            特:<span>{{typeof consumer_data.userCoin[props.row.user_id] != "undefined" ?consumer_data.userCoin[props.row.user_id]['special_coin']:0 }}</span>
                        </el-form-item>
                        <el-form-item label="使用日额度：">
                            总:<span>{{ typeof consumer_data.userQuota[props.row.user_id] != "undefined" ? consumer_data.userQuota[props.row.user_id]['total_quota']:0 }}</span>
                            普:<span>{{typeof consumer_data.userQuota[props.row.user_id] != "undefined" ?consumer_data.userQuota[props.row.user_id]['ordinary_quota']:0 }}</span>
                            精:<span>{{ typeof consumer_data.userQuota[props.row.user_id] != "undefined" ?consumer_data.userQuota[props.row.user_id]['fine_quota']:0}}</span>
                            特:<span>{{typeof consumer_data.userQuota[props.row.user_id] != "undefined" ?consumer_data.userQuota[props.row.user_id]['special_quota']:0 }}</span>
                        </el-form-item>
                        <el-form-item label="总下载次数：">
                            总:<span>{{ typeof consumer_data.userCoin[props.row.user_id] != "undefined"  ? consumer_data.userCoin[props.row.user_id]['total_num']:0 }}</span>
                            普:<span>{{typeof consumer_data.userCoin[props.row.user_id] != "undefined" ?consumer_data.userCoin[props.row.user_id]['ordinary_num']:0 }}</span>
                            精:<span>{{ typeof consumer_data.userCoin[props.row.user_id]!= "undefined"  ?consumer_data.userCoin[props.row.user_id]['fine_num']:0}}</span>
                            特:<span>{{typeof consumer_data.userCoin[props.row.user_id]!= "undefined"  ?consumer_data.userCoin[props.row.user_id]['special_num']:0 }}</span>
                        </el-form-item>
                    </el-form>
                </template>
            </el-table-column>
            <el-table-column type="selection" v-if="!alreadyRelation" :selectable="selectable"></el-table-column>
            <el-table-column prop="user_id" label="uid"></el-table-column>
            <el-table-column prop="username" label="用户名"></el-table-column>
            <el-table-column prop="real_name" label="真实姓名"></el-table-column>
            <el-table-column prop="properties" label="属性" class="cell">
                <template slot-scope="scope">
                    <span v-if="scope.row.is_common==true">公有</span>
                    <span v-else>私有</span>
                </template>
            </el-table-column>
            <el-table-column prop="identity" label="身份" align="center" class-name="cell">
                <template slot-scope="scope">
                    <div>{{scope.row.identity_name}}<span v-if="scope.row.is_admin==1" style="color:red;">（管理员）</span>
                    </div>
                </template>
            </el-table-column>
            <!--<el-table-column label="操作" v-if="alreadyRelation">-->
                <!--<template slot-scope="scope">-->
                    <!--<el-button type="text" @click.stop="removeRelation(scope.row)">移除</el-button>-->
                <!--</template>-->
            <!--</el-table-column>-->
        </el-table>
        <el-row v-if="linkPage">
            <pagination :linkPage="linkPage" :enableEvent="true" style="text-align: center;margin-top: 5px;"
                        @change="watchPageChange"></pagination>
        </el-row>
        <div slot="footer" class="dialog-footer" style="text-align: center;margin-top: 15px;" v-if="!alreadyRelation">
            <el-button type="info" @click="handleClose">关闭</el-button>
            <el-button type="primary" @click="confirmRelation">确定关联</el-button>
        </div>
    </div>
</template>
<style>
    .demo-table-expand {
        font-size: 0;
    }
    .demo-table-expand label {
        width: 290px;
        color: #99a9bf;
    }
    .demo-table-expand .el-form-item {
        margin-right: 0;
        margin-bottom: 0;
        width: 50%;
    }
</style>

<script>
    import AccountServiceNew from '~/services/account'
    import AccountService from "~/services/CustomerAccounts"
    import RelationForm from "~/views/customer/relationForm.vue";
    import Pagination from "~/widgets/Pagination.vue";
    import CustomerGroupService from "~/services/customerGroup";

    export default {
        components: {
            Pagination,
            RelationForm
        },
        data() {
            return {
                is_get_remote_data: false,
                identity: {},  //存取身份对象
                properties: {}, //账号属性
                multipleSelection: [],
                alreadySelect: [],
                input_size: 'mini',
                linkPage: null,
                loading: true,
                dialogVisible: false,
                formLabelWidth: '180px',
                accounts: [],    //所有账号
                alreadyRelationAccounts: [],//已关联的账号
                selectedAll:[],//全选数据存储
                dict:[],//字典集，不能修改
                consumer_data:{
                    userCoin:[],
                    userQuota:[]
                },
                searchVal: {
                    user_id: '',
                    username: '',
                    real_name: '',
                    identity: '0',
                    is_join: '',
                },
            }
        },
        props: {
            /**
             * 学校ID，新版排课开多产品传入
             * 每个学校ID代表一个单独的排课产品
             */
            schoolId: {
                type: String,
                required: true,
            },
            /**
             *  {
             *      "service_key": "xwt",
             *      "service_name": "校网通"
             *  },
             *  {
             *      "service_key": "jb2",
             *      "service_name": "校本2"
             *  },
             *  {
             *      "service_key": "jb3",
             *      "service_name": "校本3"
             *  },
             *  {
             *      "service_key": "szxy",
             *      "service_name": "数字化校园"
             *  },
             *  {
             *      "service_key": "zujuan",
             *      "service_name": "二一组卷"
             *  },
             *  {
             *      "service_key": "zujuan_org",
             *      "service_name": "组卷合作机构"
             *      }
             */
            service: {
                required: true
            },
            //客户id
            customerId: {
                required: true,
            },
            //用户组id 可以理解为车厢id
            group_id: {
                required: false
            },
            //查看已关联用户
            alreadyRelation: {
                type: Array,
                required: false,
            }
        },
        created: async function () {
            this.identity = AccountService.getIndentify();
            this.properties = AccountService.getProperties();
            let params = {};
            params['customer_id'] = this.customerId;
            if (params['identity'] == 0) delete params['identity'];
            await this.getAlreadyAccounts(params);

            console.log(this.alreadyRelation, "<<<<<");

            if(typeof this.alreadyRelation == "undefined" ){ await this.getAccounts(params);}

        },
        watch:{
            'alreadyRelationAccounts':function(){
            }
        },
        updated() {
            this.selectedAccount();
        },
        destroyed(){
            console.log('i am  destroyed');
        },
        methods: {
            selectable(row){
                let is_able = true;
                Object.keys(this.dict).forEach((key, index)=>{
                    if(this.dict[key]['user_id']==row['user_id']){
                        is_able = false;
                    }
                })
                return is_able;
            },
            getAlready(){

                this.getAccounts({customer_id:this.customerId,service:this.service});
            },
            destroy(){
                this.$destroy();
            },
            selectedAccount() {

                console.log(this.alreadyRelationAccounts, "##");

                setTimeout(() => {
                    this.accounts.forEach((item, index) => {
                        if (this.alreadyRelationAccounts.length > 0) {
                            if (this.alreadyRelationAccounts.find(i => {
                                return i.user_id == item.user_id
                            })) {
                                this.$refs.multipleTable.toggleRowSelection(this.accounts[index], true);
                            }
                        }
                    })
                }, 100)
            },
            removeRelation(data) {
                this.$confirm('此操作将账号从当前用户组移除, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning',
                    center: true
                }).then(() => {
                    /**
                     *进行账号移除操作
                     */
                    let remove = '';
                    if(this.group_id){
                        remove = CustomerGroupService.removeRelations({group_id:this.group_id,customer_id:this.customerId,accounts:[data.user_id]});
                    }else{
                        remove = AccountService.disable({service:this.service,customer_id:this.customerId,accounts: [data.user_id]});
                    }
                    remove.then(res => {
                        if (res.code == 0) {
                            this.accounts = this.accounts.filter(i => {
                                return i.user_id != data.user_id;
                            })
                            this.$emit('removeAccount', data);
                            this.$message({
                                type: 'success',
                                message: '移除成功!'
                            });
                        }
                    });

                }).catch(() => {
                });
            },
            // 导出账号
            exportAccount() {
                let elemIF = document.createElement("iframe");
                var access_token = AccountServiceNew.getAccessTokenByCache();
                let url = '';
                if(this.service == 'division' || this.service == 'paike_new') {
                     url = 'https://scrm.21cnjy.net/customer/accounts/export?customer_id=' + this.customerId;
                     if(this.searchVal.username !='') {
                         url +='&username='+this.searchVal.username;
                     }
                    if(this.searchVal.user_id !='') {
                        url +='&user_id='+this.searchVal.user_id;
                    }
                    if(this.searchVal.real_name !='') {
                        url +='&real_name='+this.searchVal.real_name;
                    }
                }else{
                     url = 'https://scrm.21cnjy.net/customer/accounts/export?customer_id=' + this.customerId;
                }

                if(this.alreadyRelation){
                    url+= '&service='+this.service;
                    if(this.group_id) url += '&group_id='+this.group_id
                }
                if (access_token) {
                  url += '&access-token='+access_token
                }
                elemIF.width = 0;
                elemIF.height = 0;
                elemIF.src = url;
                elemIF.style.display = "none";
                document.body.appendChild(elemIF);
            },
            confirmRelation() {
                if (!this.alreadyRelationAccounts) {
                    this.$message({
                        message: '请选择关联的账号',
                        type: 'warning'
                    });
                    return false
                }
                if(this.service == 'paike_new') { //排课因为有查询密码，需要一次性全部参数提交过去，这里分开处理
                    // if (this.alreadyRelationAccounts.length>3) {
                    //     this.$message({
                    //         message: '最多只能选3个管理员账号',
                    //         type: 'warning'
                    //     });
                    //     return false
                    // }
                    this.$emit('relationAccount', this.alreadyRelationAccounts);
                    this.handleClose();
                }else{

                    let uids = [];
                    this.alreadyRelationAccounts.forEach(item => {
                        uids.push(item.user_id);
                    })
                    let request = '';
                    if(this.group_id){
                        request = CustomerGroupService.buildRelations({group_id:this.group_id,customer_id:this.customerId,accounts: uids})
                    }else{
                        request = AccountService.activeAccounts({service:this.service,customer_id:this.customerId,accounts: uids});
                    }
                    request.then(res => {
                        if (res.code == 0) {
                            this.$emit('relationAccount', this.alreadyRelationAccounts);
                            this.$message('关联成功');
                            this.handleClose();
                        }
                    })
                }

            },
            handleClose() {
                this.$emit('handleClose', false)
            },
            watchPageChange(pageParams) {
                let params = {};
                params['customer_id'] = this.customerId;
                params['page'] = pageParams["page"];
                params['perPage'] = pageParams["perPage"];
                if(this.group_id) params['group_id'] == this.group_id;
                if(typeof this.alreadyRelation == "undefined" ){
                    this.getAccounts(params);
                }else{
                    this.getAlreadyAccounts(params);
                }
            },
            submitSearch() {
                let params = this.searchVal;
                params['customer_id'] = this.customerId;
                if (params['identity'] == 0) delete params['identity'];
                if(this.group_id) params['group_id'] == this.group_id;
                if(typeof this.alreadyRelation == "undefined" ){
                    this.getAccounts(params);
                }else{
                    this.getAlreadyAccounts(params);
                }
            },
            handleChange(data){
                this.multipleSelection = data;
                this.selectedAll = Object.assign(this.selectedAll,data);
            },
            //全选全不选
            handleAllSelect(data){
                if(data.length>0){//全选
                   this.selectedAll = Object.assign(this.selectedAll,data);
                   this.selectedAll.map(item=>{
                       let isChecked = this.alreadyRelationAccounts.find(i=>{return i.user_id==item.user_id});
                       if(!isChecked){
                            this.alreadyRelationAccounts.push(item)
                       }
                   })
                }else{//全不选
                    this.selectedAll.map(item=>{
                         _.remove(this.alreadyRelationAccounts, (i) => {
                            return i.user_id == item.user_id;
                        })
                    })
                    this.selectedAll = Object.assign([],[]);
                }
            },
            // 获取选中账号数组
            handleSelectionChange(rows,row) {
                this.multipleSelection = rows;
                if(this.alreadyRelation) return false;
                let selected = rows.length && rows.includes(row)
                if (selected) {//选中
                    this.alreadyRelationAccounts.push(row);
                } else {//未选中
                     _.remove(this.alreadyRelationAccounts, (item) => {
                        return item.user_id == row.user_id;
                    })
                }
            },
            rowClick(row) {
                if(!this.selectable(row)) return false;
                if(typeof this.alreadyRelation != "undefined") return false;
                this.$refs.multipleTable.toggleRowSelection(row);
                let selected = this.multipleSelection.length && this.multipleSelection.includes(row)
                if (selected) {//选中
                    this.alreadyRelationAccounts.push(row);
                } else {//未选中
                    this.alreadyRelationAccounts = _.remove(this.alreadyRelationAccounts, (item) => {
                        return item.user_id != row.user_id;
                    })
                }
            },

            async getAccounts(params) {
                let condition = Object.assign({},params);
                //查询是否关联
                if(condition['is_join'] > 0){
                    if(this.group_id) condition['group_id'] = this.group_id;
                    condition['service'] = this.service;
                }
                console.log('getAccounts:', condition);
                await AccountService.accountFilter(condition).then(res => {
                    this.accounts = [];
                    if (res.data) {
                        this.accounts = res.data;
                    }
                    this.loading = false;
                    if (res._meta) {
                        this.linkPage = res._meta;
                    }
                })
            },
            async getAlreadyAccounts(params){
               let condition = Object.assign({},params);
                if(this.group_id) condition['group_id'] = this.group_id;
                if(typeof this.alreadyRelation == "undefined") condition['enable_page'] = 0;
                condition['service'] = this.service;
                console.log('getAlreadyAccounts:', condition);
                await AccountService.accountFilter(condition).then(res => {

                    this.alreadyRelationAccounts = [];
                    if(typeof this.alreadyRelation != "undefined") this.accounts = [];
                    if (res.data) {
                        this.alreadyRelationAccounts = res.data;
                        if(!(this.service == 'division' || this.service=='paike_new')){
                            this.dict = Object.assign({},res.data);
                        }

                        // 新排课多产品，过滤掉其他学校线的账号不允许勾选
                        if (this.service == 'paike_new') {
                            let filterRows = [];
                            console.log("inSchoolId", this.schoolId);
                            res.data.forEach(item => {
                                if (item.schoolId && item.schoolId.toString() !== this.schoolId) {
                                    filterRows.push(item);
                                }
                            })
                            this.dict = Object.assign({},filterRows);
                        }

                        if(typeof this.alreadyRelation != "undefined") this.accounts = res.data;
                        if(this.alreadyRelation && this.group_id){
                            this.getConsumerData(this.group_id);
                        }
                    }
                    if(typeof this.alreadyRelation != "undefined"){
                        this.loading = false;
                        if (res._meta) {
                            this.linkPage = res._meta;
                        }
                    }
                })
            },
            /**
             *获取用户组用户消费情况
             */
            getConsumerData(group_id)
            {
                let uids = [];
                this.accounts.forEach(i=>{
                    uids.push(i.user_id);
                });
                AccountService.getConsumerData({group_id:group_id,uids:uids}).then(res=>{
                    this.consumer_data = res.data;
                })
            },
            toAccount() {
                let path = "/customers/view?id=" + this.customerId + "&tab=Accounts";
                this.$router.push({
                    path: path,
                    query: {
                        referer: this.$route.path
                    }
                });
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/views/customer/relationForm.vue